<template>
  <div class="width-height-percent aj-center">
    <barcode
      :value="text"
      :width="width"
      :height="height"
      :fontSize="fontSize"
      :background="background"
      :lineColor="lineColor"
    ></barcode>
  </div>
</template>
<script>

import barcode from "vue-barcode";

export default {
  components: {
    barcode
  },
  data () {
    return {}
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '2'
    },
    height: {
      type: String,
      default: '100'
    },
    fontSize: {
      type: String,
      default: '20'
    },
    background: {
      type: String,
      default: '#ffffff'
    },
    lineColor: {
      type: String,
      default: '#000000'
    }
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.width-height-percent{
  width: 100%;
  height: 100%;
}
</style>
